import { ListItem, ListItemIcon, Chip, withStyles, StyledComponentProps, Divider, IconButton } from '@material-ui/core';
import { Contact, Check, MenuContacts } from '../../../ui-components/Icons';

import * as React from 'react';
import { contact } from '../../../model/contact';
import { ContactInfo } from '../../contacts/components/List/ContactInfo';
import { styles } from '../styles';


interface IContactItemProps extends StyledComponentProps {
    contact: contact;
    onContactClick: (sub: string) => void;
    getChatMessages: (sub: string) => void;
    setSelectedUser: (sub: string) => void;
    goToContact:(sub: string) => void;
    isSelected: boolean;
    unreadcount: number;
}

class UserComponent extends React.Component<IContactItemProps> {
    state = { open: false }

    private handleClick = (sub: string) => {
        this.props.onContactClick(sub);
        this.props.setSelectedUser(sub);
        this.props.getChatMessages(sub);
    }

    render() {
        const { contact, unreadcount, classes } = this.props;
        const isOnline = contact.connectionId && contact.connectionId !== ``;

        return (
            <>
                <ListItem button
                    className={this.props.isSelected ? this.props.classes.selectedContact : ''}
                    onClick={(e) => this.handleClick(contact.sub)}>
                    <ListItemIcon>
                        <Contact />
                    </ListItemIcon>
                    <ContactInfo contact={this.props.contact} classes={classes} />
                    {isOnline && <Check className={classes.OnlineCheck} />}
                    <Chip variant={'outlined'} label={unreadcount} className={unreadcount ? classes.UserChipUnread : classes.UserChipNoUnread} />
                    <IconButton onClick={(e) => {
                        e.stopPropagation();
                        this.props.goToContact(contact.sub)
                    }}>
                        <MenuContacts />
                    </IconButton>
                </ListItem>
                <Divider />
            </>
        );
    }
}
export const User = withStyles(styles)(UserComponent);
